export default __webpack_public_path__ + "0c59687afef16e7bb2ae96cbe9760299.jpg";